import { Action } from '@ngrx/store';
import { Cart } from '../cart/cart.model';
import { Passenger } from '..';

export enum CartActionTypes {
  CreateCart = '[Cart] Create Cart',
  CartCreated = '[Cart] Created Cart',
  CartDeleted = '[Cart] Deleted Cart',
  EndRelatedCartSession = '[Cart] KickOther Cart',
  DeleteCart = '[Cart] Delete Cart',
  CartUpdated = '[Cart] Cart Updated',
  UpdateCartRequested = '[Cart] Update Cart Requested',
  BagSendRequested = '[Cart] Bag Send Requested',
  AddBag = '[Cart] Add Bag',
  RemoveBag = '[Cart] Remove Bag',
  PaxSelectedForSpecialItems = '[Cart] Pax Selected For Special Items',
  PaxSelectedChangedForSpecialItems = '[Cart] Pax Selected Changed',
  SessionEnd = '[Cart] Session End',
  RelatedCartRetrieved = '[Cart] Related Cart retrieved',
  EmptyCheckout = '[Cart] Empty Checkout',
  EmptyCheckoutSuccessful = '[Cart] Empty Checkout Successful',
  UpdateCartAndGoToNextStep = '[Cart] Update Cart And Go To Next Step',
  RemoveSeat = '[Cart] Remove Seat',
  AddSeat = '[Cart] Add Seat',
}

export class RelatedCartRetrieved implements Action {
  readonly type = CartActionTypes.RelatedCartRetrieved;
  constructor(public payload: { cart: Cart }) {}
}

export class CartCreated implements Action {
  readonly type = CartActionTypes.CartCreated;
  constructor(public payload: { cart: Cart }) {}
}

export class CreateCart implements Action {
  readonly type = CartActionTypes.CreateCart;
}
export class EndRelatedCartSession implements Action {
  readonly type = CartActionTypes.EndRelatedCartSession;
}
export class CartDeleted implements Action {
  readonly type = CartActionTypes.CartDeleted;
}

export class DeleteCart implements Action {
  readonly type = CartActionTypes.DeleteCart;
}

export class CartUpdated implements Action {
  readonly type = CartActionTypes.CartUpdated;
  constructor(public payload: { cart: Cart }) {}
}

export class UpdateCartRequested implements Action {
  readonly type = CartActionTypes.UpdateCartRequested;
}

export class EmptyCheckout implements Action {
  readonly type = CartActionTypes.EmptyCheckout;
}

export class EmptyCheckoutSuccessful implements Action {
  readonly type = CartActionTypes.EmptyCheckoutSuccessful;
}

export class UpdateCartAndGoToNextStep implements Action {
  readonly type = CartActionTypes.UpdateCartAndGoToNextStep;
}

export class BagSendRequested implements Action {
  readonly type = CartActionTypes.BagSendRequested;
}

export class AddBag implements Action {
  readonly type = CartActionTypes.AddBag;
  constructor(
    public payload: {
      productId: string;
      passengerId: string;
      segmentId: string;
    }
  ) {}
}

export class RemoveBag implements Action {
  readonly type = CartActionTypes.RemoveBag;
  constructor(
    public payload: {
      productId: string;
      passengerId: string;
      segmentId: string;
    }
  ) {}
}
export class RemoveSeat implements Action {
  readonly type = CartActionTypes.RemoveSeat;
  constructor(
    public payload: {
      productId?: string;
      passengerId: string;
      segmentId: string;
      flightId: string;
    }
  ) {}
}
export class AddSeat implements Action {
  readonly type = CartActionTypes.AddSeat;
  constructor(
    public payload: {
      productId: string;
      passengerId: string;
      segmentId: string;
      assignment: string;
      flightId: string;
      price: any;
      quantity: number;
    }
  ) {}
}

export class PaxSelectedForSpecialItems implements Action {
  readonly type = CartActionTypes.PaxSelectedForSpecialItems;
  constructor(public payload: { passengerId: string }) {}
}

export class PaxSelectedChangedForSpecialItems implements Action {
  readonly type = CartActionTypes.PaxSelectedChangedForSpecialItems;
  constructor(public payload: { passenger: Passenger }) {}
}

export class SessionEnd implements Action {
  readonly type = CartActionTypes.SessionEnd;
}

export type CartActions =
  | CreateCart
  | CartCreated
  | CartDeleted
  | DeleteCart
  | BagSendRequested
  | AddBag
  | RemoveBag
  | AddSeat
  | RemoveSeat
  | CartUpdated
  | UpdateCartRequested
  | UpdateCartAndGoToNextStep
  | PaxSelectedForSpecialItems
  | PaxSelectedChangedForSpecialItems
  | SessionEnd
  | EmptyCheckout
  | RelatedCartRetrieved;
